import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getDynamicWorkflowStatus } from 'state/dynamic/selectors';
import { getStaticWorkflowStatus, WorkFlowStatus } from 'state/selectors';
import { AppState } from 'state/state.model';
import { QuoteWorkspaceType } from 'state/workspaces/model';

import { AddonActionSwitch } from './AddonActionSwitch';

function componentForStatus(status: WorkFlowStatus) {
  switch (status) {
    case 'QUOTED':
    case 'QUOTED_TRADABLE':
      return AddonActionSwitch;
    default:
      return null;
  }
}

export interface TradeWayProps {
  workspaceType: QuoteWorkspaceType;
  tabId: string;
}

export const AddonAction: FC<TradeWayProps> = ({ workspaceType, tabId }) => {
  const status = useSelector(getWorkflowStatus(workspaceType, tabId));
  const AddonActionComponent = componentForStatus(status);

  return (
    AddonActionComponent !== null && (
      <GenericErrorBoundary key={tabId}>
        <AddonActionComponent e2e="side-panel-addon-action" tabId={tabId} workspaceType={workspaceType} />
      </GenericErrorBoundary>
    )
  );
};

function getWorkflowStatus(workspaceType: QuoteWorkspaceType, tabId: string) {
  return (state: AppState) =>
    workspaceType === 'static' ? getStaticWorkflowStatus(state, tabId) : getDynamicWorkflowStatus(state, tabId);
}
